import React, {useState} from "react";
import { ContainerTable, TableView } from "../../../components/Table";
import { formatCurrency, roundNumber, getDexWallet, createDexWallet } from "../../../services/app";
import { useApp } from "../../../contexts";
import {
  ContainerTableMobile,
  TextCellTable,
} from "../styles";
import { CellRowImage } from "../styles";
import { useNavigate } from "react-router-dom";
import {
  DesktopContainer,
  MobileContainer,
} from "../../../components/Container";
import { WalletRowItemSOT } from "./WalletRowItemSOT";
import { RecordNotFound } from "../../../components/RecordNotFound";
import { dateFormat, getCoinCodeImage } from "../../../utils/helper";
import { error } from "../../../Notification";
import { ModalMintNotify } from "../../../components/ModalMintNotify";

export const TableOption = ({ data, visible, tab }) => {
  const { T, formatLocalCurrency } = useApp();
  const navigate = useNavigate();
  const [isShowCreateWeb3, setIsShowCreatWeb3] = useState(false);
  const [isBtnLoading, $isBtnLoading] = useState(false);
  const [isShowCreateWeb3Success, setIsShowCreatWeb3Success] = useState(false);
  const columns = [
    {
      title: T("Opportunity token"),
      dataIndex: "coin",
      key: "coin",
      width: 300,
      sorter: (a, b) => a.coin.toString().localeCompare(b.coin),
      render: (text, record, index) => {
        return (
          <CellRowImage style={{ minWidth: 60 }}>
            <img
              alt=""
              style={{ width: 28, height: 28 }}
              src={`/assets/images/otc/crypto/${getCoinCodeImage(
                text
              )?.toLowerCase()}.svg`}
            />
            <span style={{ marginLeft: 4 }}>{text}</span>
          </CellRowImage>
        );
      },
    },
    {
      title: T("Market Price"),
      dataIndex: "marketPrice",
      key: "btcValue",
      align: "right",
      className: "btc-value",
      width: 200,
      sorter: (a, b) => a.marketPrice - b.marketPrice,
      render: (text, record, index) => (
        <TextCellTable>
          {formatLocalCurrency(roundNumber(record.marketPrice, 2))}
        </TextCellTable>
      ),
    },
    {
      title: T("Amount"),
      dataIndex: "originBalance",
      key: "originBalance",
      align: "right",
      width: 300,
      render: (text, record, index) => (
        <TextCellTable>{formatCurrency(record.originBalance, 8)}</TextCellTable>
      ),
    },
    
    {
      title: T("Claimable Amount"),
      dataIndex: "claimableBalance",
      key: "claimableBalance",
      align: "right",
      width: 300,
      render: (text, record, index) => (
        <TextCellTable>{formatCurrency(record.claimableBalance, 8)}</TextCellTable>
      ),
    },
    {
      title: T("Total Value"),
      dataIndex: "local",
      key: "local",
      align: "right",
      width: 300,
      render: (text, record, index) => (
        <TextCellTable>{formatLocalCurrency(roundNumber(record.local, 2))}</TextCellTable>
      ),
    },
    {
      title: T("Release On"),
      dataIndex: "releaseOn",
      key: "releaseOn",
      align: "right",
      width: 200,
      render: (text, record, index) => (
        record.claimableBalance > 0 ? 
        // false ? 
        <div className="flex justify-end w-full">
          <button type="button"
            className="bg-black text-[14px] font-semibold rounded-[15px] min-w-[96px] h-[40px]"
            onClick={(e) => {e.stopPropagation(); onClaim(record)}}
          >
            <div className="bg-black px-[10px] w-[calc(100%-2px)] flex items-center justify-center mx-[1px] h-[calc(100%-2.2px)] my-[1px] rounded-[15px]">
              <span className="text-white bg-black">{T('Claim')}</span>
            </div>
          </button>
        </div>:  <span className="text-black font-normal">{dateFormat(record.releaseTime, 'YYYY/MM/DD')}</span>
      ),
    },
  ];
  const onClaim = async (item) => {
    try {
      const resultDexWallet = await getDexWallet();
      if(resultDexWallet && resultDexWallet.data && resultDexWallet.data.data && resultDexWallet.data.data.public_address) {
        navigate(
          `/claim-sot?code=${item.currency_code}`
        );
      }else{
        setIsShowCreatWeb3(true)
      }
    }catch(e){
      setIsShowCreatWeb3(true)
    }
  }
  const hanldeCreateWeb3Address = async () => {
    try {
      if (isBtnLoading) return
      $isBtnLoading(true)
      const createResult = await createDexWallet();
      if (createResult?.data?.error?.status) {
        setIsShowCreatWeb3(false);
        setIsShowCreatWeb3Success(true);
      } else {
        error(T(createResult?.data?.error?.message));
        setIsShowCreatWeb3(false);
      }
    } catch (e) {
      error(T("Create web3 wallet unsuccessfully"));
      setIsShowCreatWeb3(false);
    }
    $isBtnLoading(false)
  };
  const onDetail = (record) => {
    navigate(`/wallet-detail/option/?code=${record.currencyCode}`);
  };
  return (
    <div>
      <div className="mt-[10px] lg:mt-[20px]">
        <DesktopContainer>
          <ContainerTable>
            <TableView
              scroll={{ x: true }}
              tableLayout={"fixed"}
              pagination={false}
              dataSource={data}
              columns={columns}
              isClickRow
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    onDetail(record);
                  },
                };
              }}
            />
          </ContainerTable>
        </DesktopContainer>
        <MobileContainer>
          {data?.length ? (
            <ContainerTableMobile>
              {data?.map((item, index) => (
                <WalletRowItemSOT
                  onClick={() => onDetail(item)}
                  key={item.id}
                  coin={item.coin}
                  item={item}
                  marketPrice={formatLocalCurrency(
                    roundNumber(item.marketPrice, 2)
                  )}
                  onClaim={onClaim}
                  amount={formatCurrency(item.originBalance, 8)}
                  local={formatLocalCurrency(roundNumber(item.local, 2))}
                />
              ))}
            </ContainerTableMobile>
          ) : (
            <RecordNotFound />
          )}
        </MobileContainer>
      </div>
      {isShowCreateWeb3 && (
        <ModalMintNotify
          onClose={() => setIsShowCreatWeb3(false)}
          onSubmit={() => hanldeCreateWeb3Address()}
          isLoading={isBtnLoading}
          title={T("AI Avatar Web3 Wallet not found!")}
          des={T(
            "You need to have a AI Avatar Web3 Wallet to use this function. Please create a AI Avatar Wallet and try again!"
          )}
          buttonText={T("Create Web3 Wallet")}
        />
      )}
      {isShowCreateWeb3Success && (
        <ModalMintNotify
          onClose={() => setIsShowCreatWeb3Success(false)}
          onSubmit={() => handleMint()}
          title={T("Created web3 wallet successfully")}
          des={T(
            "Your web3 wallet has been created successfully. Please access your web3 wallet on AI Avatar app. Now you can convert SOT to SGT using AI Avatar Web3 wallet."
          )}
          buttonText={T("Continue to claim")}
        />
      )}
    </div>
  );
};
